// extracted by mini-css-extract-plugin
export default {"projectImageContainer":"projectImage_projectImageContainer__6pI3M","projectImage":"projectImage_projectImage__nI2X4"};